import { addFormatToken } from '../format-functions';
import { getMinutes } from '../utils/date-getters';
addFormatToken('m', ['mm', 2], null, function (date) {
    return getMinutes(date).toString(10);
});
//# sourceMappingURL=minute.js.map


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/ngx-bootstrap/bs-moment/units/minute.js
// module id = ../../../../ngx-bootstrap/bs-moment/units/minute.js
// module chunks = 3